// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"72c04634","166":"918f6136","287":"85b4cd5c","312":"2b7836fe","453":"670e15c7","484":"286ae595","551":"df42166b","672":"bacf3c4a","683":"f630cfc8","842":"0f834115","851":"b8b870c7","965":"936ccd68"}[chunkId] + ".chunk.js";
};